import { PaymentProcessorConfigurationBase } from '../payment-processor-configuration-base';

export class InvoiceCloudPaymentProcessorConfiguration extends PaymentProcessorConfigurationBase {
  constructor(options?: Partial<InvoiceCloudPaymentProcessorConfiguration>) {
    super(options);
    if (options) {
      Object.assign(this, options);
    }
  }
}